import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/** Page / section header for list views: title + summary on the left, actions on the right. */
@Component({
  selector: 'app-list-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <header class="pp-list-header" [class.pp-list-header--compact]="compact">
      <div class="pp-list-header__titles">
        <h1 *ngIf="!compact">{{ heading }}</h1>
        <h2 *ngIf="compact" class="pp-list-header__h2">{{ heading }}</h2>
        <p *ngIf="summaryText" class="pp-sub" aria-live="polite">{{ summaryText }}</p>
        <ng-content select="[headerSub]"></ng-content>
      </div>
      <div class="pp-list-header__actions">
        <ng-content></ng-content>
      </div>
    </header>
  `,
  styles: [':host { display: block; }'],
})
export class ListHeaderComponent {
  @Input() heading = '';
  @Input() summary: string | null = null;
  @Input() compact = false;
  /** With `noun`, renders "12 clients" when no explicit summary is given. */
  @Input() count: number | null | undefined = null;
  @Input() noun = '';
  @Input() nounPlural = '';

  get summaryText(): string | null {
    if (this.summary) return this.summary;
    if (!this.noun || this.count === null || this.count === undefined) return null;
    const n = Number(this.count) || 0;
    const word = n === 1 ? this.noun : this.nounPlural || `${this.noun}s`;
    return `${n.toLocaleString()} ${word}`;
  }
}
